module.exports = __webpack_public_path__ + "static/media/cases_ident_visual_lg_03.1c971ae0.jpg";